import styles from './ErrorMessage.module.scss';

interface ErrorMessageProps {
  error: string;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({ error }) => (
  <section className={styles['error-message-container']}>
    <span className="caption1">{error}</span>
  </section>
);
